// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xfn8B","col":"styles_col__1FxCd"};